import { ThemeUICSSObject } from 'theme-ui';
import rangeFilter from './rangeFilter';

/* IMPORT HERE */
const filters: ThemeUICSSObject = {
  rangeFilter,
  /* PREPEND HERE */
};
export default filters;
